export const style = {
  wrapper: {
    '@media (min-width: 992px)': {
      padding: `0 25px`
    }
  },
  box: {
    padding: `15px`,
    '@media (min-width: 992px)': {
      padding: `20px`,
      borderRadius: `3px`,
      border: `1px solid #ddd`
    }
  },
  listBox: {
    '@media (min-width: 992px)': {
      paddingLeft: `25px`
    }
  },
  row: {
    padding: 0,
    ':not(:last-of-type)': {
      borderBottom: `1px solid #ddd`
    }
  },
  label: {
    fontSize: `15px`,
    paddingTop: `6px`
  },
  value: {
    fontSize: `15px`,
    fontWeight: 500,
    lineHeight: `35px`,
    alignText: `right`
  },
  firstlabel: {
    color: `#A94545`,
    fontWeight: 600
  },
  firstValue: {
    color: `#A94545`,
    fontWeight: 600
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/topgeo.js